const convertOptions = list => {
  return list.map(type => {
    return { text: type.Name, value: type.Id, key: type.Id };
  });
};

export { convertOptions };
